// extracted by mini-css-extract-plugin
module.exports = {"tariffButton":"_1LL2Q","tariffItem":"_1qP9j","disabled":"jBcof","selected":"_1uQPm"};